import { Pipe, PipeTransform } from '@angular/core';

import { ConfigService } from '../../../../core';
import { ConfigEmpresa, createNomeRepresentante, isIdentificacaoRepresentanteNome } from '../../../configuracoes/app/empresa';

@Pipe({
    name: 'representanteNome'
})
/** Pipe utilizado para exibir o nome do representante conforme forma de identificação configurada pela empresa */
export class RepresentanteNomePipe implements PipeTransform {
    configEmpresa: ConfigEmpresa;

    constructor(private configService: ConfigService) {
        this.configEmpresa = this.configService.getEmpresa();
    }

    /** Retorna o nome primário do Representante conforme a identificação do representante pela empresa selecionada na configuração da Empresa */
    transform(nome: string, nomeFantasia: string, codigoIntegracaoErp: string = null): string {
        let codigo = '';
        // Somente adiciona o código quando informado e a identificação for pelo nome
        if (codigoIntegracaoErp) { // && isIdentificacaoRepresentanteNome(this.configEmpresa.identificacaoCliente)
            codigo = `${codigoIntegracaoErp} - `;
        }
        return  `${codigo}${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, nome, nomeFantasia)}`;
    }
}
